// @ts-nocheck

import { request } from '../context';
import type { ApiOptions } from '../context';
import type {
    BaseResponseFeishuConfigFoundResponse,
    PostFeishuConfigsBody,
    BaseResponseVoid,
} from '../types';

/**
 * 查询飞书集成配置
 *
 * @export
 * @tags feishu-config-controller
 * @link [GET] /feishuConfigs
 */
export function getFeishuConfigs(): Promise<BaseResponseFeishuConfigFoundResponse>;
export function getFeishuConfigs(
    options: ApiOptions<never, never>
): Promise<BaseResponseFeishuConfigFoundResponse>;
export function getFeishuConfigs(
    options?: ApiOptions<never, never>
): Promise<BaseResponseFeishuConfigFoundResponse> {
    return request<never, never, never>('/feishuConfigs', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getFeishuConfigs',
    });
}

/**
 * 保存/修改飞书集成配置
 *
 * @export
 * @tags feishu-config-controller
 * @link [POST] /feishuConfigs
 */
export function postFeishuConfigs(data: PostFeishuConfigsBody): Promise<BaseResponseVoid>;
export function postFeishuConfigs(
    data: PostFeishuConfigsBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseVoid>;
export function postFeishuConfigs(
    data: PostFeishuConfigsBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseVoid> {
    return request<PostFeishuConfigsBody, never, never>('/feishuConfigs', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postFeishuConfigs',
    });
}

export const meta = [
    { tags: ['feishu-config-controller'], path: '/feishuConfigs', method: 'get' },
    { tags: ['feishu-config-controller'], path: '/feishuConfigs', method: 'post' },
];
